<template>
    <div class="content">
        <div class="card card-default">
            <div class="card-header">
                <h3 class="card-title"> </h3>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-toggle="dropdown" title="Công cụ">
                        <i class="fas fa-cogs"></i>
                        <div class="input-group-prepend">
                            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                <a class="dropdown-item text-green" href="#" @click="detail(null, 'create')">
                                    <i class="fas fa-plus"></i>&nbsp;&nbsp;Tạo mới
                                </a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item text-red" href="#" @click="showDeleteManyModal()">
                                    <i class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;Xóa đã chọn
                                </a>
                                <div class="dropdown-divider"></div>
                                <export-excel class="dropdown-item text-green" :data="exportDatas" worksheet="user" type="xls" name="user.xls">
                                    <i class="fas fa-file-excel"></i>&nbsp;&nbsp;Xuất file Excel
                                </export-excel>
                                <div class="dropdown-divider"></div>
                            </div>
                        </div>
                    </button>
                    <button type="button" class="btn btn-tool" @click="getData" title="Tải lại">
                        <i class="fas fa-arrows-rotate"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Thu gọn">
                        <i class="fas fa-minus"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Ẩn">
                        <i class="fas fa-times"></i>
                    </button>

                </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
                <div class="row mb-2">
                    <div class="col-md-3 mb-3">
                        <TheSelect id="" title="" :options="pageOptions" :initialValue="perPage.toString()" @onChange="(v) => onChangePageOptions(v)" />
                    </div>
                    <div class="col-md-6"></div>
                    <div class="col-md-3">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Nhập  từ khóa tìm kiếm" v-model="filter">
                            <div class="input-group-append">
                                <span class="input-group-text" @click="onSearchKey" role="button">
                                    <i class="fas fa-search"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive p-0">
                    <!-- loading overlay -->
                    <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>
                    <!-- table data -->
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th class="col5">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                            @click="selectAllRows($event)">
                                        <label for="checkboxAll" class="custom-control-label"></label>
                                    </div>
                                </th>
                                <th class="col5">#</th>
                                <th class="col80">Họ tên</th>
                                <th>Tên đăng nhập</th>
                                <th>Email</th>
                                <th>Số điện thoại</th>
                                <th class="col200">Process</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td @click="selectRow(item.id)" style="cursor: pointer;" title="Chọn item">
                                    <span v-if="(selected.includes(item.id))" aria-hidden="true"
                                        class="text-primary">&check;</span>
                                    <span v-else aria-hidden="true">&nbsp;</span>
                                </td>
                                <td @click="selectRow(item.id)">{{ item.rowNumber }}</td>
                                <td @click="selectRow(item.id)">{{ item.fullname }}</td>
                                <td @click="selectRow(item.id)">{{ item.username }}</td>
                                <td @click="selectRow(item.id)">{{ item.email }}</td>
                                <td @click="selectRow(item.id)">{{ item.phoneNumber }}</td>
                                <td>
                                    <button type="button" size="sm" class="btn btn-outline-success btn-xs"
                                        v-on:click="detail(item, 'detail')">
                                        <i class="fas fa-eye"></i>
                                    </button>&nbsp;
                                    <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                        v-on:click="detail(item, 'update')">
                                        <i class="fas fa-pencil-alt"></i>
                                    </button>&nbsp;
                                    <button type="button" size="sm" class="btn btn-outline-warning btn-xs"
                                        v-on:click="showResetPassModal(item.id)">
                                        <i class="fas fa-key"></i>
                                    </button>&nbsp;
                                    <button type="button" size="sm" class="btn btn-outline-danger btn-xs"
                                        v-on:click="showDeleteConfirm(item.id)">
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <p> Selected Rows:<br>{{ selected }} </p> -->
                <!-- row info and paging -->
                <div class="row">
                    <div class="col-md-6">
                        <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng</div>
                        <div v-else>Không có dữ liệu</div>
                    </div>
                    <div class="col-md-6">
                        <div class="float-right">
                            <ul class="pagination pagination-rounded">
                                <paginate :page-count="pageCount" :page-range="3" :margin-pages="2"
                                    :click-handler="handlePageChange" :prev-text="'Trở lại'" :next-text="'Kế đến'"
                                    :container-class="'pagination'" :page-class="'page-item'">
                                </paginate>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--POP UP DETAIL-->
        <div class="modal fade" id="detailModal" data-keyboard="false" data-backdrop="dynamic"> <!-- data-backdrop="static" -->
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{ title }}</h4>
                        <button type="button" class="close" aria-label="Close" @click="hideDetailModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- <input type="hidden" v-model="model.id" /> -->
                        <div class="row mb-2">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                Họ tên <span class="text-danger">(*)</span>
                            </label>
                            <div class="col-sm-9">
                                <input class="form-control" placeholder="Nhập họ tên" v-model="model.fullname" :readonly="code == 'detail'" @blur="validate()" :class="{ 'is-invalid': errors.fullname }" />
                            </div>
                        </div>
                        <small class="text-danger text-right mb-2 d-block" style="margin-top: -13 !important;" v-if="errors.fullname">{{ errors.fullname }}</small>

                        <div class="row mb-2">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                Tên đăng nhập <span class="text-danger">(*)</span>
                            </label>
                            <div class="col-sm-9">
                                <input class="form-control" placeholder="Nhập tên đăng nhập" v-model="model.username" :readonly="code == 'detail' || code == 'update'" @blur="validate()" :class="{ 'is-invalid': errors.username }" />
                            </div>
                        </div>
                        <small class="text-danger text-right mb-2 d-block" v-if="errors.username">{{ errors.username }}</small>

                        <div class="row mb-2" v-if="code == 'create'">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                Mật khẩu <span class="text-danger">(*)</span>
                            </label>
                            <div class="col-sm-9">
                                <input class="form-control" type="password" placeholder="Nhập mật khẩu" v-model="model.password" @blur="validate()" :class="{ 'is-invalid': errors.password }" />
                            </div>
                        </div>
                        <small class="text-danger text-right mb-2 d-block" v-if="errors.password && code == 'create'">{{ errors.password }}</small>

                        <div class="row mb-2" v-if="code == 'create'">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                Xác nhận mật khẩu <span class="text-danger">(*)</span>
                            </label>
                            <div class="col-sm-9">
                                <input class="form-control" type="password" placeholder="Nhập lại mật khẩu" v-model="model.repassword" @blur="validate()" :class="{ 'is-invalid': errors.repassword }" />
                            </div>
                        </div>
                        <small class="text-danger text-right mb-2 d-block" v-if="errors.repassword && code == 'create'">{{ errors.repassword }}</small>

                        <div class="row mb-2">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                Email <span class="text-danger">(*)</span>
                            </label>
                            <div class="col-sm-9">
                                <input class="form-control" placeholder="Nhập email" v-model="model.email" :readonly="code == 'detail'" @blur="validate()" :class="{ 'is-invalid': errors.email }" />
                            </div>
                        </div>
                        <small class="text-danger text-right mb-2 d-block" v-if="errors.email">{{ errors.email }}</small>

                        <div class="row mb-2">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                Số điện thoại <span class="text-danger">(*)</span>
                            </label>
                            <div class="col-sm-9">
                                <input class="form-control" placeholder="Nhập số điện thoại" v-model="model.phoneNumber" :readonly="code == 'detail'" @blur="validate()" :class="{ 'is-invalid': errors.phoneNumber }" />
                            </div>
                        </div>
                        <small class="text-danger text-right mb-2 d-block" v-if="errors.phoneNumber">{{ errors.phoneNumber }}</small>

                        <div class="row mb-2">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                Phân quyền <span class="text-danger">(*)</span>
                            </label>
                            <div class="col-sm-9">
                                <div class="col-auto my-1" v-for="role in roles" :key="role.id">
                                    <div class="custom-control custom-checkbox mr-sm-2">
                                        <input type="checkbox" class="custom-control-input" :value="role.id" :id="role.id" name="selectRole" @change="onSelectRole($event)" :checked="model.roles.includes(role.id)">
                                        <label class="custom-control-label" :for="role.id">{{ role.roleName }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <small class="text-danger text-right mb-2 d-block" v-if="errors.role">{{ errors.role }}</small>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-outline-dark pull-left" @click="hideDetailModal()">&nbsp;Đóng</button>
                        <button type="button" class="pull-right" :disabled="submitted" :class="styleButton" v-if="code != 'detail'" @click="onSubmit();">
                            <span v-if="submitted" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            &nbsp;{{ title }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- POP UP CONFIRM DELETE  -->
        <div class="modal fade" id="deleteConfirm" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-danger">Xóa người dùng</h4>
                        <button type="button" class="close" aria-label="Close" @click="hideDeleteConfirm()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <label>Xóa người dùng này?</label>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-outline-dark pull-left" @click="hideDeleteConfirm()">&nbsp;Đóng</button>
                        <button type="button" class="btn btn-outline-danger pull-right" @click="onSubmitDelete();">&nbsp;Xóa</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- POP UP CONFIRM DELETE MANY  -->
        <div class="modal fade" id="deleteManyModal" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-danger">Xóa</h4>
                        <button type="button" class="close" aria-label="Close" @click="hideDeleteManyModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <label>Bạn có chắc chắn xóa các item đã chọn?</label>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-outline-dark pull-left" @click="hideDeleteManyModal()">&nbsp;Đóng</button>
                        <button type="button" class="btn btn-outline-danger pull-right" @click="onDeleteManySubmit();">&nbsp;Xóa</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Reset password modal -->
        <div class="modal fade" id="resetPassModal" data-keyboard="false" data-backdrop="dynamic"> <!-- data-backdrop="static" -->
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Reset mật khẩu</h4>
                        <button type="button" class="close" aria-label="Close" @click="hideResetPassModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row mb-2">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                Mật khẩu mới <span class="text-danger">(*)</span>
                            </label>
                            <div class="col-sm-9">
                                <input type="password" class="form-control" placeholder="Nhập mật khẩu mới" v-model="newPass" @blur="validateResetPass()" :class="{ 'is-invalid': errors.newPass }" />
                            </div>
                        </div>
                        <small class="text-danger text-right mb-2 d-block" style="margin-top: -13 !important;" v-if="errors.newPass">{{ errors.newPass }}</small>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-outline-dark pull-left" @click="hideResetPassModal()">&nbsp;Đóng</button>
                        <button type="button" class="btn btn-outline-warning pull-right" :disabled="submitted" :class="styleButton" @click="onResetPassSubmit();">Reset</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import { userModel } from '@/models/user.model.js'
import config from '@/config/prod.env';
import common from '@/helper/common.js';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import TheSelect from '@/components/shared/UserInput/TheSelect.vue';

export default {
    components: {
        paginate: Paginate,
        loading: Loading,
        TheSelect
    },
    name: "TheUser",
    data() {
        return {
            isBusy: false,
            // table
            filter: null,
            items: [],
            exportDatas: [],
            currentPage: config.CURRENT_PAGE,
            perPage: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,
            totalRow: 0,
            pageCount: 0,
            sortBy: "createdDate",
            sortDesc: true,
            filterOn: [],
            numberOfShow: 0,

            roles: [],

            // model 
            model: userModel.newModel(),

            selectedId: '',
            newPass: "",

            title: "",
            code: "",
            styleButton: "",
            // For mesage validate
            errors: {},
            submitted: false,
            selected: [],
            rowSelected: null,
            isUpdate: false
        }
    },
    methods: {
        // Map action
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('role', ['getAllRole',]),
        ...mapActions('user', ['getAll', 'getAllPagingUser', 'getByID', 'isExistUsername',  'createUser', 'updateUser', 'deleteUser', 'deleteManyUser', 'resetPass']),
        ...mapActions('alert', ['warning',]),
        // setup
        async setup() {
            //setup dynamic header
            let header = 'Quản lý người dùng'
            this.setupHeader({ header })
        },

        // ------ get data datatable ------
        async getData() {
            // get list roles
            let rs1 = await this.getAllRole();
            if(rs1.isOk) {
                this.roles = rs1.data.data;
            }

            // state for loading overlay
            this.isBusy = true;
            // Set param for paging
            let params = {
                currentPage: this.currentPage,
                perPage: this.perPage,
                sortBy: this.sortBy,
                sortDesc: this.sortDesc,
                searchKey: this.filter
            };
            // Call get data
            let rs2 = await this.getAllPagingUser(params);
            if(rs2.isOk) {
                // List data
                this.items = rs2.data.data;
                // Total row
                this.totalRow = rs2.data.totalRow;
                // Number show
                this.numberOfShow = ((this.currentPage - 1) * this.perPage) + this.items.length;
                // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.perPage)) + 1;
                // For export excel
                this.exportDatas = this.items.map(({ rowNumber, id, username, fullname, email, phoneNumber }) => ({
                    rowNumber, id, username, fullname, email, phoneNumber
                }));
            }
            this.isBusy = false;
        },        
        // sortingChanged
        async sortingChanged() {
            //console.log(this.perPage)
            await this.getData();
        },
        // function for paging
        async handlePageChange(page) {
            this.currentPage = page;
            //console.log(this.currentPage)
            await this.getData();
        },
        // function for select number in page
        async onChangePageOptions(perPage) {
            this.perPage = perPage;
            await this.getData();
        },
        // function for search key 
        async onSearchKey() {
            //console.log(this.filter)
            //this.filter = e.target.value
            await this.getData();
        },
        // function select item in table
        async selectRow(id) {
            if (this.selected.includes(id)) {
                this.selected.splice(this.selected.indexOf(id), 1);
            }
            else {
                this.selected.push(id);
            }
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.selected = this.items.map((item) =>  item.id);
            }
            else {
                this.selected = [];
            }
        },
        
        // ------ show/hide detail popup ------
        async detail(item, code) {
            // set notifi error
            this.errors = {
                
            };
            // prepare model
            this.code = code;
            this.title = this.$t('labels.' + code);
            this.styleButton = this.$t('labels.styleButton' + code);
            this.model = item != null ? item : userModel.newModel();
            this.isUpdate = (code == "create") ? false : true;
            // show popup
            this.showDetailModal();
        },
        async showDetailModal() {
            $('#detailModal').modal('show');
        },
        async hideDetailModal() {
            $('#detailModal').modal('hide');
            await this.getData();
        },

        // ------ on select role ------
        onSelectRole(e){
            if(e.target.checked){
                this.model.roles.push(e.target.value);
            } else {
                this.model.roles = this.model.roles.filter(r => r != e.target.value);
            }
        },

        // ------ show/hide delete confirm ------
        async showDeleteConfirm(id) {
            this.selectedId = id;
            $('#deleteConfirm').modal('show');
        },
        async hideDeleteConfirm() {
            $('#deleteConfirm').modal('hide');
        },
        
        // ------ show/hide delete many confirm modal ------
        async showDeleteManyModal() {
            if (this.selected.length == 0) {
                this.warning('Chưa chọn dòng để xóa');
            }
            else {
                $('#deleteManyModal').modal('show');
            }
        },
        async hideDeleteManyModal() {
            $('#deleteManyModal').modal('hide');
        },

        // ------ show/hide reset pass modal ------
        async showResetPassModal(id) {
            this.selectedId = id;
            this.newPass = '';
            this.errors.newPass = '';
            $('#resetPassModal').modal('show');
        },
        async hideResetPassModal() {
            $('#resetPassModal').modal('hide');
        },

        // ------ function validate ------
        async validate() {
            let isvalid = true
            this.errors = {
                fullname: '',
                username: '',
                password: '',
                repassword: '',
                email: '',
                phoneNumber: '',
                role: ''
            };

            // check null model
            if (!this.model.fullname) {
                this.errors.fullname = "Nhập họ tên";
                isvalid = false;
            }

            if (!this.model.username) {
                this.errors.username = 'Nhập  tên đăng nhập';
                isvalid = false;
            } else if(this.code === 'create') {
                // check exist username
                let rs = await this.isExistUsername(this.model.username);
                if(rs.data) {
                    this.errors.username = 'Đã tồn tại người dùng này';
                    isvalid = false;
                }
            }

            if(this.code == 'create') {
                if (!common.validatePassword(this.model.password)) {
                    this.errors.password = "Mật khẩu phải có độ dài 8 kí tự trở lên, có chứa số, kí tự đặc biệt, kí tự hoa và thường";
                    isvalid = false;
                }

                if (this.model.password != this.model.repassword) {
                    this.errors.repassword = "Mật khẩu không khớp";
                    isvalid = false;
                }
            }

            if (!this.model.email) {
                this.errors.email = 'Nhập email';
                isvalid = false;
            } else if (!common.validateEmail(this.model.email)) {
                this.errors.email = 'Không phải email';
                isvalid = false;
            }

            if (!this.model.phoneNumber) {
                this.errors.phoneNumber = 'Nhập số điện thoại';
                isvalid = false;
            } else if (!common.validatePhoneNumber(this.model.phoneNumber)) {
                this.errors.phoneNumber = 'Không phải số điện thoại';
                isvalid = false;
            }

            if (this.model.roles.length <= 0) {
                this.errors.role = 'Chọn phân quyền';
                isvalid = false;
            }
            return isvalid;
        },
        // validate reset pass
        async validateResetPass() {
            let isvalid = true
            this.errors = {
                newPass: ''
            };

            if (!this.newPass) {
                this.errors.newPass = "Nhập mật khẩu";
                isvalid = false;
            } else if (!common.validatePassword(this.newPass)) {
                this.errors.newPass = "Mật khẩu phải có độ dài 8 kí tự trở lên, có chứa số, kí tự đặc biệt, kí tự hoa và thường";
                isvalid = false;
            }

            return isvalid;
        },

        // ------ create, update submit ------
        async onSubmit() {
            this.submitted = true;
            if (await this.validate()) {
                // create
                if (this.code == "create") {
                    await this.createUser(this.model);
                }
                // update
                if (this.code == "update") {
                    await this.updateUser(this.model);
                }
                this.hideDetailModal();
                await this.getData();
            }
            this.submitted = false;
        },

        // ------ delete submit ------
        async onSubmitDelete() {
            await this.deleteUser(this.selectedId);
            this.getData();
            this.hideDeleteConfirm();
        },
        
        // ------ delete many submit ------
        async onDeleteManySubmit() {
            if (this.selected.length == 0) {
                this.warning('Chưa chọn dòng để xóa');
            }
            else {
                let ids = [];
                ids = this.selected.map(item => item);
                await this.deleteManyUser(ids);
                await this.getData();
                this.selected = [];
            }
            await this.hideDeleteManyModal();
        },

        // ------ reset pass submit ------
        async onResetPassSubmit() {
            this.submitted = true;
            if (await this.validateResetPass()) {
                await this.resetPass({id: this.selectedId, newPass: this.newPass});
                this.hideResetPassModal();
            }
            this.submitted = false;
        },
    },
    async mounted() {
        // setup title header
        await this.setup();
        // get data table
        await this.getData();
    },
    async created() {

    }
}
</script>

<style>

</style>
